import React from 'react';
import css from './style.scss';
import {Link} from 'react-router-dom';
import {FullContainer} from 'components/container';
import moment from 'moment'
import store from 'utils/store'
import {push} from 'react-router-redux'

class FooterName extends React.Component {
  constructor(props){
    super(props)
    this.state={
      count:0,
      year:moment().get("year")
    }
  }
  demoEasterEgg=()=>{
    this.setState({count:this.state.count+1})
    if(this.state.count>5){
      store.dispatch(push("/a/demo"))
    }
  }
  render(){
    return (
      <div className={css.copy} onClick={this.demoEasterEgg}>
      © {this.state.year} - <b>stori</b>.social
      </div>
    )
  }
}

export const Footer=(props)=>{
  return (
      <FullContainer grey classContainer={css.footerContainer}>
        <div className={css.footer}>
          <FooterName/>
          <div className={css.links}>
            <Link to="/privacy">Privacy</Link>
            <Link to="/faq">FAQ</Link>
            <a target="_blank" rel="noopener noreferrer" href="https://www.twitter.com/stori_social/">@stori.social</a>
            <a target="_blank" rel="noopener noreferrer" className={css.right} href="mailto:hello@stori.social">Got Feedback? Contact us</a>
          </div>
        </div>
      </FullContainer>
  )
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js